<div class="score-page">
    <section class="card-plain">
        <div class="filter-grid">
            <app-select-academic-year-only
                (academicYearChanged)="onChangeAcademicYear($event); clearData()"
                [group_by_period]="true"
                [all_academic_year]="true">
            </app-select-academic-year-only>
            <app-select-school-level-relation-v2
                [academic_year]="this.paramForm.get('academic_year')?.value"
                [period_id]="this.paramForm.get('period_id')?.value"
                (schoolLevelRelationChanged)="onChangeSchoolLevel($event); clearData()"
                [task]="'SCHOOL_PROGRAM_SCORING_VIEW'"
                [useSupervisorAccess]="true"
                [supervisorLocationAccess]="this.supervisorLocationAccess">
            </app-select-school-level-relation-v2>
            <app-select-school-program
                [academic_year]="this.paramForm.get('academic_year')?.value"
                [school_location_id]="this.paramForm.get('school_location_id')?.value"
                (schoolProgramChanged)="onChangeSchoolProgram($event); clearData()">
            </app-select-school-program>
            <app-select-school-program-category
                [school_program_id]="this.paramForm.get('school_program_id')?.value"
                [all]="true"
                (schoolProgramCategoryChanged)="onChangeSchoolProgramCategory($event); clearData()">
            </app-select-school-program-category>
            <app-select-school-activity
                (schoolActivityChanged)="onChangeSchoolProgramActivity($event); clearData()"
                [academic_year]="this.paramForm.get('academic_year')?.value"
                [school_program_id]="this.paramForm.get('school_program_id')?.value"
                [school_program_category_id]="this.paramForm.get('school_program_category_id')?.value">
            </app-select-school-activity>
        </div>
    </section>

    @if (!paramForm.controls['school_program_activity_id'].value) {
        <p class="hint">{{ 'PLEASE_SELECT_ACTIVITY' | translate }}</p>
    } @else if (loading.legend) {
        <app-status-loading [show]="true"></app-status-loading>
    } @else if (!showTableScore) {
        <p class="hint">{{ 'SCORE_NOT_SET' | translate }}</p>
    } @else {
        <section class="card-plain">
            <h2 class="section-title">{{ 'ACTIVITY_SCORE_LEGEND' | translate }}</h2>
            <div class="guide-grid">
                @for (score of scoreRange; track score.activity_score_range_id) {
                    <div class="guide">
                        <h3 class="guide__name">{{ score.score_name }}</h3>
                        <table class="guide__table">
                            <thead>
                                <tr>
                                    <th>{{ 'PREDICATE' | translate }}</th>
                                    @if (usingScoreRange) {
                                        <th>{{ 'Range' | translate }}</th>
                                    }
                                    <th>{{ 'DESCRIPTION' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (detail of score.score_detail; track $index) {
                                    <tr>
                                        <td class="guide__predicate"><span class="predicate-badge">{{ detail.predicate }}</span></td>
                                        @if (usingScoreRange) {
                                            <td class="guide__range">{{ detail.min_score ?? '-' }}–{{ detail.max_score ?? '-' }}</td>
                                        }
                                        <td class="guide__desc">{{ detail.description || '-' }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </section>

        <section class="card-plain card-plain--flush">
            <header class="grid-head">
                <div>
                    <h2 class="section-title section-title--flat">
                        {{ 'STUDENT_SCORE' | translate }}
                        @if (showTableStudent) {
                            <span class="section-title__count">{{ rows.length }}</span>
                        }
                    </h2>
                    @if (showTableStudent && canEdit) {
                        <p class="grid-tip">{{ 'Copy and paste from Excel works here. Drag the corner of a selection to fill cells below.' | translate }}</p>
                    }
                </div>
                @if (auth.permissions['SCHOOL_PROGRAM_PERIOD_SETUP_ADD']) {
                    <button type="button" class="action-btn action-btn-edit head-btn" (click)="onUploadExcel()">
                        <i-feather name="upload"></i-feather>{{ 'UPLOAD_SCORE' | translate }}
                    </button>
                }
            </header>

            @if (loading.student) {
                <app-status-loading [show]="true"></app-status-loading>
            } @else if (warningText) {
                <p class="warning">{{ warningText }}</p>
            } @else if (showTableStudent) {
                <div #gridWrap class="score-grid-wrap">
                <revo-grid
                    #scoreGrid
                    class="score-grid"
                    theme="material"
                    [style.height.px]="gridHeight"
                    [columns]="columns"
                    [columnTypes]="columnTypes"
                    [source]="rows"
                    [rowSize]="rowSize"
                    [readonly]="!canEdit || saving"
                    [applyOnClose]="true"
                    [resize]="true"
                    [range]="true"
                    [canFocus]="true"
                    [useClipboard]="clipboardConfig"
                    [rowHeaders]="true"
                    [stretch]="true"
                    [hideAttribution]="true"
                    (beforekeydown)="onGridKeydown($event)"
                    (afteredit)="onAfterEdit($event)">
                </revo-grid>
                </div>

                @if (canEdit) {
                    <footer class="grid-footer">
                        <span class="grid-footer__status">
                            @if (invalidCount > 0) {
                                <span class="status-invalid"><span class="revo-grid-legend-swatch"></span>{{ invalidCount }} {{ 'cell(s) to fix' | translate }}</span>
                            }
                            @if (changedCount > 0) {
                                <span class="status-changed">{{ changedCount }} {{ 'student(s) changed' | translate }}</span>
                            }
                        </span>
                        <button type="button" class="action-btn action-btn-create" (click)="onSaveScore()" [disabled]="saving">
                            {{ (saving ? 'Saving…' : 'Save') | translate }}
                        </button>
                    </footer>
                }
            }
        </section>
    }
</div>

<ng-template #uploadTemplate let-modal> 
    <div class="modal-header">
        <div class="row">
            <div class="col-md-12 d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ 'UPLOAD_SCORE' | translate }}</h5>
                <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
            </div>
        </div>
    </div>
    <div class="modal-body">
        <button class="btn btn-primary mb-2" size="tiny" (click)="onDownloadTemplate()" *ngIf="excelButtonCondition">{{ 'DOWNLOAD_TEMPLATE' | translate }}</button>
        <ngx-dropzone (change)="uploadExcel($event)" [multiple]="false" [accept]="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'">
            <ngx-dropzone-label>
                <div class="d-flex flex-column align-items-center justify-content-center">
                    <i class="fa fa-upload fa-2x mb-2"></i>
                    <span>{{ 'DRAG_DROP_EXCEL' | translate }}</span>
                </div>
            </ngx-dropzone-label>
        </ngx-dropzone>
    </div>
</ng-template>
